import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withKeys as _withKeys, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition } from "vue"

const _hoisted_1 = { class: "platform-logs-filters" }
const _hoisted_2 = { class: "bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden mb-4" }
const _hoisted_3 = { class: "flex items-center space-x-3 space-x-reverse" }
const _hoisted_4 = { class: "px-4 py-3 bg-gray-50 border-b border-gray-200" }
const _hoisted_5 = { class: "grid grid-cols-1 md:grid-cols-3 gap-3" }
const _hoisted_6 = { class: "md:col-span-2" }
const _hoisted_7 = { class: "flex gap-2" }
const _hoisted_8 = {
  key: 0,
  class: "px-4 py-4 space-y-4"
}
const _hoisted_9 = { class: "grid grid-cols-1 md:grid-cols-4 gap-3" }
const _hoisted_10 = { class: "border-t border-gray-200 pt-4" }
const _hoisted_11 = {
  key: 0,
  class: "space-y-3"
}
const _hoisted_12 = { class: "grid grid-cols-1 md:grid-cols-3 gap-3" }
const _hoisted_13 = { class: "grid grid-cols-1 md:grid-cols-2 gap-3" }
const _hoisted_14 = { class: "grid grid-cols-1 md:grid-cols-3 gap-3" }
const _hoisted_15 = { class: "flex gap-4 pt-2" }
const _hoisted_16 = { class: "flex gap-2 pt-3 border-t border-gray-200" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_spacer = _resolveComponent("v-spacer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "px-4 py-3 bg-gradient-to-r from-blue-500 to-blue-600 cursor-pointer flex items-center justify-between",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleAdvancedFilters && _ctx.toggleAdvancedFilters(...args)))
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_v_icon, { color: "white" }, {
            default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
              _createTextVNode("mdi-filter-variant", -1)
            ]))]),
            _: 1
          }),
          _cache[19] || (_cache[19] = _createElementVNode("h3", { class: "text-white font-semibold text-base" }, "جستجوی پیشرفته", -1)),
          _createVNode(_component_v_chip, {
            small: "",
            class: "bg-white bg-opacity-20"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.activeFiltersCount) + " فیلتر فعال ", 1)
            ]),
            _: 1
          })
        ]),
        _createVNode(_component_v_icon, {
          color: "white",
          class: _normalizeClass(["transition-transform duration-300", { 'rotate-180': _ctx.showAdvanced }])
        }, {
          default: _withCtx(() => [...(_cache[20] || (_cache[20] = [
            _createTextVNode(" mdi-chevron-down ", -1)
          ]))]),
          _: 1
        }, 8, ["class"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_v_text_field, {
              modelValue: _ctx.localFilters.search,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.localFilters.search) = $event)),
              label: "جستجوی سریع",
              placeholder: "جستجو در توضیحات، IP، نام کاربر، اکشن...",
              "prepend-inner-icon": "mdi-magnify",
              clearable: "",
              outlined: "",
              dense: "",
              "hide-details": "",
              class: "compact-input",
              onKeyup: _withKeys(_ctx.applyFilters, ["enter"])
            }, null, 8, ["modelValue", "onKeyup"])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_v_btn, {
              color: "primary",
              onClick: _ctx.applyFilters,
              loading: _ctx.loading,
              class: "flex-1 h-10",
              elevation: "1"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, {
                  small: "",
                  class: "ml-1"
                }, {
                  default: _withCtx(() => [...(_cache[21] || (_cache[21] = [
                    _createTextVNode("mdi-magnify", -1)
                  ]))]),
                  _: 1
                }),
                _cache[22] || (_cache[22] = _createTextVNode(" جستجو ", -1))
              ]),
              _: 1
            }, 8, ["onClick", "loading"]),
            _createVNode(_component_v_btn, {
              color: "gray",
              outlined: "",
              onClick: _ctx.resetFilters,
              class: "h-10"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, { small: "" }, {
                  default: _withCtx(() => [...(_cache[23] || (_cache[23] = [
                    _createTextVNode("mdi-refresh", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ])
      ]),
      _createVNode(_Transition, { name: "slide-fade" }, {
        default: _withCtx(() => [
          (_ctx.showAdvanced)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_component_v_select, {
                    modelValue: _ctx.localFilters.type,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.localFilters.type) = $event)),
                    items: _ctx.typeOptions,
                    label: "نوع لاگ",
                    multiple: "",
                    outlined: "",
                    dense: "",
                    clearable: "",
                    "hide-details": "",
                    class: "compact-input",
                    chips: "",
                    "small-chips": ""
                  }, null, 8, ["modelValue", "items"]),
                  _createVNode(_component_v_select, {
                    modelValue: _ctx.localFilters.status,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.localFilters.status) = $event)),
                    items: _ctx.statusOptions,
                    label: "وضعیت",
                    multiple: "",
                    outlined: "",
                    dense: "",
                    clearable: "",
                    "hide-details": "",
                    class: "compact-input",
                    chips: "",
                    "small-chips": ""
                  }, null, 8, ["modelValue", "items"]),
                  _createVNode(_component_v_text_field, {
                    modelValue: _ctx.localFilters.userId,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.localFilters.userId) = $event)),
                    label: "شناسه کاربر",
                    outlined: "",
                    dense: "",
                    clearable: "",
                    "hide-details": "",
                    class: "compact-input"
                  }, null, 8, ["modelValue"]),
                  _createVNode(_component_v_text_field, {
                    modelValue: _ctx.localFilters.referenceId,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.localFilters.referenceId) = $event)),
                    label: "شناسه مرجع",
                    outlined: "",
                    dense: "",
                    clearable: "",
                    "hide-details": "",
                    class: "compact-input"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("button", {
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.showMoreFilters = !_ctx.showMoreFilters)),
                    class: "text-sm text-blue-600 hover:text-blue-700 font-medium flex items-center gap-2 mb-3"
                  }, [
                    _createVNode(_component_v_icon, {
                      small: "",
                      class: _normalizeClass({ 'rotate-180': _ctx.showMoreFilters })
                    }, {
                      default: _withCtx(() => [...(_cache[24] || (_cache[24] = [
                        _createTextVNode("mdi-chevron-down", -1)
                      ]))]),
                      _: 1
                    }, 8, ["class"]),
                    _createTextVNode(" " + _toDisplayString(_ctx.showMoreFilters ? 'فیلترهای کمتر' : 'فیلترهای بیشتر'), 1)
                  ]),
                  _createVNode(_Transition, { name: "slide-fade" }, {
                    default: _withCtx(() => [
                      (_ctx.showMoreFilters)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                            _createElementVNode("div", _hoisted_12, [
                              _createVNode(_component_v_text_field, {
                                modelValue: _ctx.localFilters.userEmail,
                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.localFilters.userEmail) = $event)),
                                label: "ایمیل کاربر",
                                outlined: "",
                                dense: "",
                                clearable: "",
                                "hide-details": "",
                                class: "compact-input"
                              }, null, 8, ["modelValue"]),
                              _createVNode(_component_v_text_field, {
                                modelValue: _ctx.localFilters.adminEmail,
                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.localFilters.adminEmail) = $event)),
                                label: "ایمیل ادمین",
                                outlined: "",
                                dense: "",
                                clearable: "",
                                "hide-details": "",
                                class: "compact-input"
                              }, null, 8, ["modelValue"]),
                              _createVNode(_component_v_text_field, {
                                modelValue: _ctx.localFilters.targetEmail,
                                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.localFilters.targetEmail) = $event)),
                                label: "ایمیل کاربر هدف",
                                outlined: "",
                                dense: "",
                                clearable: "",
                                "hide-details": "",
                                class: "compact-input"
                              }, null, 8, ["modelValue"])
                            ]),
                            _createElementVNode("div", _hoisted_13, [
                              _createVNode(_component_v_text_field, {
                                modelValue: _ctx.localFilters.from,
                                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.localFilters.from) = $event)),
                                label: "از تاریخ",
                                outlined: "",
                                dense: "",
                                clearable: "",
                                "hide-details": "",
                                placeholder: "2025-01-01T00:00:00Z",
                                class: "compact-input"
                              }, null, 8, ["modelValue"]),
                              _createVNode(_component_v_text_field, {
                                modelValue: _ctx.localFilters.to,
                                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.localFilters.to) = $event)),
                                label: "تا تاریخ",
                                outlined: "",
                                dense: "",
                                clearable: "",
                                "hide-details": "",
                                placeholder: "2025-12-31T23:59:59Z",
                                class: "compact-input"
                              }, null, 8, ["modelValue"])
                            ]),
                            _createElementVNode("div", _hoisted_14, [
                              _createVNode(_component_v_text_field, {
                                modelValue: _ctx.localFilters.ip,
                                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.localFilters.ip) = $event)),
                                label: "آدرس IP",
                                outlined: "",
                                dense: "",
                                clearable: "",
                                "hide-details": "",
                                class: "compact-input"
                              }, null, 8, ["modelValue"]),
                              _createVNode(_component_v_select, {
                                modelValue: _ctx.localFilters.device,
                                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.localFilters.device) = $event)),
                                items: _ctx.deviceOptions,
                                label: "نوع دستگاه",
                                outlined: "",
                                dense: "",
                                clearable: "",
                                "hide-details": "",
                                class: "compact-input"
                              }, null, 8, ["modelValue", "items"]),
                              _createVNode(_component_v_text_field, {
                                modelValue: _ctx.localFilters.actionContains,
                                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.localFilters.actionContains) = $event)),
                                label: "جستجو در اکشن",
                                outlined: "",
                                dense: "",
                                clearable: "",
                                "hide-details": "",
                                class: "compact-input"
                              }, null, 8, ["modelValue"])
                            ]),
                            _createElementVNode("div", _hoisted_15, [
                              _createVNode(_component_v_checkbox, {
                                modelValue: _ctx.localFilters.hasError,
                                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.localFilters.hasError) = $event)),
                                label: "فقط لاگ‌های دارای خطا",
                                "hide-details": "",
                                dense: "",
                                class: "mt-0"
                              }, null, 8, ["modelValue"]),
                              _createVNode(_component_v_checkbox, {
                                modelValue: _ctx.localFilters.isRead,
                                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.localFilters.isRead) = $event)),
                                label: "خوانده شده",
                                "hide-details": "",
                                dense: "",
                                class: "mt-0"
                              }, null, 8, ["modelValue"])
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _createVNode(_component_v_btn, {
                    color: "primary",
                    onClick: _ctx.applyFilters,
                    loading: _ctx.loading,
                    elevation: "1"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, {
                        small: "",
                        class: "ml-1"
                      }, {
                        default: _withCtx(() => [...(_cache[25] || (_cache[25] = [
                          _createTextVNode("mdi-filter", -1)
                        ]))]),
                        _: 1
                      }),
                      _cache[26] || (_cache[26] = _createTextVNode(" اعمال فیلترها ", -1))
                    ]),
                    _: 1
                  }, 8, ["onClick", "loading"]),
                  _createVNode(_component_v_btn, {
                    color: "gray",
                    outlined: "",
                    onClick: _ctx.resetFilters
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, {
                        small: "",
                        class: "ml-1"
                      }, {
                        default: _withCtx(() => [...(_cache[27] || (_cache[27] = [
                          _createTextVNode("mdi-filter-off", -1)
                        ]))]),
                        _: 1
                      }),
                      _cache[28] || (_cache[28] = _createTextVNode(" پاک کردن همه ", -1))
                    ]),
                    _: 1
                  }, 8, ["onClick"]),
                  _createVNode(_component_v_spacer),
                  _createVNode(_component_v_btn, {
                    text: "",
                    small: "",
                    onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.showAdvanced = false)),
                    class: "text-gray-600"
                  }, {
                    default: _withCtx(() => [...(_cache[29] || (_cache[29] = [
                      _createTextVNode(" بستن ", -1)
                    ]))]),
                    _: 1
                  })
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ])
  ]))
}